import { EmbeddingCollectionPage } from '@/Workspaces/EmbeddingCollection/EmbeddingCollectionPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <EmbeddingCollectionPage />
  )
}
